var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9714 2.46103C11.2231 1.6864 12.319 1.6864 12.5707 2.46103L14.225 7.55262C14.3376 7.89905 14.6604 8.13359 15.0247 8.13359L20.3783 8.1336C21.1928 8.1336 21.5314 9.17585 20.8725 9.6546L16.5413 12.8014C16.2467 13.0155 16.1233 13.395 16.2359 13.7414L17.8903 18.833C18.142 19.6076 17.2554 20.2518 16.5964 19.773L12.2653 16.6263C11.9706 16.4121 11.5715 16.4121 11.2768 16.6263L6.94568 19.773C6.28674 20.2518 5.40015 19.6076 5.65184 18.833L7.3062 13.7414C7.41876 13.395 7.29545 13.0155 7.00076 12.8014L2.6696 9.6546C2.01066 9.17585 2.34931 8.1336 3.1638 8.1336L8.51742 8.13359C8.88167 8.13359 9.20449 7.89905 9.31705 7.55262L10.9714 2.46103Z",
    fill: "#B068EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.4068f7c3f1fdc65f026ec83d9b1894f0.svg";
export { ForwardRef as ReactComponent };